export default "__VITE_ASSET__BDgeDCju__"